var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._b({attrs:{"type":_vm.type,"solo":"","outlined":"","items":_vm.items,"clearable":_vm.clearable,"flat":"","label":_vm.label,"placeholder":_vm.label,"value":_vm.value},on:{"input":(v) => _vm.$emit('input', v),"change":function($event){return _vm.$emit('change')}}},'v-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }